import React from 'react'

import { BreadcrumbStore } from './BreadcrumbStore'

export const defaultBreadcrumbStore = new BreadcrumbStore()

export const BreadcrumbContext = React.createContext<BreadcrumbStore>(defaultBreadcrumbStore)
